var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-chain-item",class:{ selected: _vm.selected, done: _vm.done },attrs:{"title":_vm.$t('modals.steps.' + _vm.name)}},[_c('icon-custom',{attrs:{"name":_vm.data.icon,"size":"xxxl","fill":_vm.fillIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }